import { render, staticRenderFns } from "./TokenHandler.vue?vue&type=template&id=6cc4f687"
import script from "./TokenHandler.vue?vue&type=script&lang=js"
export * from "./TokenHandler.vue?vue&type=script&lang=js"
import style0 from "./TokenHandler.vue?vue&type=style&index=0&id=6cc4f687&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports